<template>
  <div v-if="parents && ruleset">
    <h1>
      <span>Rule set</span>
    </h1>
    <v-btn :to="{ name: 'quoteSection', params: { id: parents.section.id } }">
      <v-icon>chevron_left</v-icon>Section
    </v-btn>
    <h2>{{ parents.section.name }}</h2>
    <p>
      <a @click="dialogHeading = true" v-if="!parents.quoteScript.published"
        >heading</a
      >
      <span>{{ ruleset.heading }}</span>
    </p>
    <h3>Rules</h3>
    <v-btn @click="createRule" v-if="!parents.quoteScript.published">
      <v-icon>add</v-icon>Rule
    </v-btn>
    <v-data-table
      hide-actions
      :headers="computedHeaders"
      :items="rules"
      class="elevation-1"
      v-if="rules"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              small
              :to="{
                name: 'quoteRule',
                params: {
                  id: props.item.id
                }
              }"
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>
            <ConditionDescription
              v-for="condition in props.item.conditions"
              :key="`condition${condition.id}`"
              :condition="condition"
            />
            <ActionDescription
              v-for="action in props.item.actions"
              :key="`action${action.id}`"
              :action="action"
            />
          </td>
          <td v-if="!parents.quoteScript.published">
            <v-btn @click="moveRule(props.item, true)" small>
              <v-icon>arrow_upward</v-icon>
            </v-btn>
            <v-btn @click="moveRule(props.item, false)" small>
              <v-icon>arrow_downward</v-icon>
            </v-btn>
            <v-btn @click="deleteRule(props.item)" color="error" small>
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogHeading" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Change heading</v-card-title
        >
        <v-card-text>Please set the heading below and click Save</v-card-text>
        <v-card-text>
          <v-text-field label="Heading" v-model="rulesetCopy.heading" outline />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click="updateHeading">
            <v-icon>save</v-icon>Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ActionDescription from "@/components/quote/quoteScript/ActionDescription";
import ConditionDescription from "@/components/quote/quoteScript/ConditionDescription";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "RuleSet",
  metaInfo() {
    return {
      title: "RuleSet",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { ActionDescription, ConditionDescription },
  computed: {
    computedHeaders() {
      if (!this.parents) {
        return undefined;
      }
      let headers = [
        {
          text: "Id",
          sortable: false
        },
        {
          text: "Actions and Conditions",
          sortable: false
        }
      ];
      if (!this.parents.quoteScript.published) {
        headers.push({
          text: "Options",
          sortable: false
        });
      }
      return headers;
    }
  },
  data() {
    return {
      ruleset: null,
      rules: null,
      dialogHeading: false,
      rulesetCopy: null,
      parents: null
    };
  },
  methods: {
    async fetchRuleset() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/rulesets/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.ruleset = response.data;
    },
    async fetchRules() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/rulesets/${this.$route.params.id}/rules`
      );
      // console.log(response.data);
      this.rules = response.data;
    },
    async fetchParents() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/rulesets/${this.$route.params.id}/parents`
      );
      // console.log(response.data);
      this.parents = response.data;
    },
    async moveRule(rule, up) {
      await nbmlaw.put(
        `/cors/admin/sales/rulesets/${this.$route.params.id}/rules/${rule.id}/move`,
        null,
        { params: { up } }
      );
      // console.log(response.data);
      this.update();
    },
    async deleteRule(rule) {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(`/cors/admin/sales/rules/${rule.id}`);
        // console.log(response.data);
        this.update();
      }
    },
    async createRule() {
      const response = await nbmlaw.post(
        `/cors/admin/sales/rulesets/${this.$route.params.id}/rules`,
        null
      );
      // console.log(response.data);
      this.$router.push({
        name: "quoteRule",
        params: {
          id: response.data
        }
      });
    },
    async updateHeading() {
      await nbmlaw.put(
        `/cors/admin/sales/rulesets/${this.$route.params.id}`,
        this.rulesetCopy
      );
      // console.log(response.data);
      this.update();
      this.dialogHeading = false;
    },
    update() {
      this.fetchRuleset();
      this.fetchRules();
      this.fetchParents();
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.update();
      }
    },
    ruleset: {
      handler() {
        this.rulesetCopy = JSON.parse(JSON.stringify(this.ruleset));
      }
    }
  }
};
</script>